import React, { useState } from "react";
import { Download } from "lucide-react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";

const CrmReportExport = ({ days = 30 }) => {
  const [loading, setLoading] = useState("");
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  const download = async (type) => {
    setLoading(type);
    try {
      const res = await fetch(`${url}/leads/reports/export?type=${type}&days=${days}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Export failed");
      const blob = await res.blob();
      const disposition = res.headers.get("Content-Disposition") || "";
      const match = disposition.match(/filename="(.+)"/);
      const filename = match?.[1] || `crm-${type}.csv`;
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
      toast.success("Report downloaded");
    } catch {
      toast.error("Could not export report");
    } finally {
      setLoading("");
    }
  };

  return (
    <div className="crm-report-export">
      <h3 className="crm-integrations__title">Export reports</h3>
      <p className="crm-insights__muted">Download CSV for management review ({days} days).</p>
      <div className="crm-report-export__actions">
        <button type="button" disabled={loading === "pipeline"} onClick={() => download("pipeline")}>
          <Download size={14} /> Pipeline by source
        </button>
        <button type="button" disabled={loading === "reps"} onClick={() => download("reps")}>
          <Download size={14} /> Rep performance
        </button>
        <button type="button" disabled={loading === "attribution"} onClick={() => download("attribution")}>
          <Download size={14} /> UTM attribution
        </button>
      </div>
    </div>
  );
};

export default CrmReportExport;
